export const candidateMethods = {
    methods: {

        /* I'M HERE BY */
        createOptionsKnownFrom(newOption) {
            if (typeof this.knownFromOthers[0] === 'object') {
                newOption = {[this.label]: newOption}
            }
            this.$emit('option:created', newOption)
            return newOption
        },

        /* EXPERIENCES */
        addExperienceValue(experience) {
            let data = {
                name: experience.name,
                standard: false
            };
            this.$store.dispatch('experiences/set', data)
        },

        /* EDUCATIONS */
        addEducationRow() {
            this.candidate.educations.push({name: null, level: null});
        },
        removeEducationRow(index) {
            this.candidate.educations.splice(index, 1);
            this.renderComponent();
        },

        /* CERTIFICATES */
        addCertificateRow() {
            this.candidate.certificates.push({name: null, achievedAt: null, validUntil: null});
        },
        removeCertificateRow(index) {
            this.candidate.certificates.splice(index, 1);
            this.renderComponent();
        },

        /* POSITIONS */
        addPositionRow() {
            this.candidate.positions.push({
                name: null,
                employer: null,
                startDate: null,
                endDate: null,
                activities: null,
                reasonLeft: null,
            });
        },
        removePositionRow(index) {
            this.candidate.positions.splice(index, 1);
            this.renderComponent();
        },

        // CHANGES TIMESTAMPS TO dd-mm-jjjj BEFORE SAVING
        convertTimestamps() {
            _.each(this.candidate.certificates, (certificate) => {
                if (certificate.validUntil) {
                    certificate.validUntil = moment(certificate.validUntil).format('YYYY-MM-DD');
                }
            });
            _.each(this.candidate.positions, (position) => {
                if (position.startDate) {
                    position.startDate = moment(position.startDate).format('YYYY-MM-DD');
                }
                if (position.endDate) {
                    position.endDate = moment(position.endDate).format('YYYY-MM-DD');
                }
            });
        },

        /* RENDER COMPONENT */
        renderComponent() {
            this.renderedComponent = false;

            this.$nextTick(() => {
                this.renderedComponent = true;
            });
        },
    }
}